import { useState } from 'react'
import { Button } from '../../components/ui/Button'
import { DateField } from '../../components/ui/DateField'
import { AsOfField } from '../../components/ui/AsOfField'
import { descarcaPdf } from './ClientPage'

/** AAAA-LL-ZZ in ora locala (`toISOString` ar muta miezul noptii in ziua de ieri). */
function ziLocala(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/**
 * „Fișa de cont PDF" cu perioada aleasă: de la (implicit prima zi a lunii trecute, ca în Tabloul de
 * bord) până la (implicit azi). Același endpoint ca Tabloul, deci aceleași cifre ca acolo.
 */
export function FisaContPdf({
  client,
  extraseLa,
  varianta = 'buton',
  eticheta = 'Fișa de cont PDF',
}: {
  client: { nume: string; cif: string | null }
  /** Ultima zi acoperită de extrase — scurtătura „ultimul extras" din „Până la". */
  extraseLa?: string | null
  varianta?: 'buton' | 'link'
  eticheta?: string
}) {
  const azi = new Date()
  const [deschis, setDeschis] = useState(false)
  const [dela, setDela] = useState(ziLocala(new Date(azi.getFullYear(), azi.getMonth() - 1, 1)))
  const [panala, setPanala] = useState(ziLocala(azi))
  const gresit =
    !dela || !panala ? 'Alege ambele date.' : dela > panala ? '„De la" e după „Până la".' : null

  const descarca = () => {
    if (gresit) return
    descarcaPdf(
      '/agents/client-reconciliation/pdf',
      {
        name: client.nume,
        ...(client.cif ? { cif: client.cif } : {}),
        startDate: dela,
        // Azi = soldul la zi, fără cererea EA la o dată din trecut (mai rapid, aceeași cifră).
        ...(panala !== ziLocala(new Date()) ? { asOf: panala } : {}),
      },
      `extras-cont-${client.nume}.pdf`,
    )
  }

  return (
    <div className="grid gap-2">
      {varianta === 'buton' ? (
        <Button variant="secondary" onClick={() => setDeschis((x) => !x)} aria-expanded={deschis}>
          {eticheta}
        </Button>
      ) : (
        <button
          type="button"
          onClick={() => setDeschis((x) => !x)}
          aria-expanded={deschis}
          className="justify-self-start text-corp font-semibold text-b4l-blue-dark hover:underline"
        >
          {eticheta}
        </button>
      )}
      {deschis && (
        <div
          role="group"
          aria-label="Perioada fișei de cont"
          className="grid gap-2 rounded-lg border border-b4l-border bg-b4l-bg-soft p-3"
        >
          <div className="flex flex-wrap items-end gap-3">
            <label className="grid gap-1 text-mic text-b4l-text-muted">
              De la
              <div className="w-36">
                <DateField value={dela} onChange={setDela} />
              </div>
            </label>
            <label className="grid gap-1 text-mic text-b4l-text-muted">
              Până la
              <span className="flex items-center gap-2">
                <AsOfField value={panala} onChange={setPanala} coverage={extraseLa ?? null} />
              </span>
            </label>
            <Button onClick={descarca} disabled={!!gresit}>
              Descarcă PDF
            </Button>
          </div>
          {gresit ? (
            <p className="text-mic text-b4l-red-dark">{gresit}</p>
          ) : (
            extraseLa &&
            panala > extraseLa && (
              <p className="text-mic text-b4l-text-muted">
                Extrasele bancare sunt încărcate până la {extraseLa.split('-').reverse().join('.')}:
                încasările de după nu apar încă.
              </p>
            )
          )}
        </div>
      )}
    </div>
  )
}
